import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="border-t border-primary-200/40 bg-primary-50">
      <div className="mx-auto max-w-content px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
                <i className="ri-chat-smile-2-fill text-lg" />
              </span>
              <span className="brand-font text-2xl text-foreground-950">深夜吃瓜</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              一个专注热话题讨论的深夜社区。每个热门瓜都有专属讨论区，看完整的来龙去脉，围观别人的观点，再发表自己的看法。瓜要一起吃，话要当面聊。
            </p>
            <a
              href="mailto:hello@shenyechigua.com"
              className="mt-5 inline-flex items-center gap-2 rounded-md border border-primary-300/50 px-3.5 py-2 text-sm text-foreground-800 transition-colors hover:border-accent-500 hover:text-accent-500"
            >
              <i className="ri-mail-send-line" />
              hello@shenyechigua.com
            </a>
          </div>

          <div className="md:col-span-3">
            <h4 className="text-sm font-semibold text-foreground-950">
              <Link to="/topics" className="transition-colors hover:text-accent-500">
                话题分类
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/topics?cat=${cat.id}`}
                    className="flex items-center gap-2 text-sm text-foreground-600 transition-colors hover:text-accent-500"
                  >
                    <i className={`${cat.icon} text-base text-secondary-500`} />
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-foreground-950">
              <Link to="/" className="transition-colors hover:text-accent-500">
                逛社区
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li>
                <Link to="/" className="transition-colors hover:text-accent-500">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/topics" className="transition-colors hover:text-accent-500">
                  话题广场
                </Link>
              </li>
              <li>
                <Link to="/rank" className="transition-colors hover:text-accent-500">
                  吃瓜热榜
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-foreground-950">
              <Link to="/about" className="transition-colors hover:text-accent-500">
                关于
              </Link>
            </h4>
            <ul className="mt-4 space-y-2.5 text-sm text-foreground-600">
              <li>
                <Link to="/about" className="transition-colors hover:text-accent-500">
                  关于我们
                </Link>
              </li>
              <li>
                <Link to="/about#principles" className="transition-colors hover:text-accent-500">
                  内容原则
                </Link>
              </li>
              <li>
                <Link to="/about#contact" className="transition-colors hover:text-accent-500">
                  联系我们
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-primary-200/40 pt-6 text-xs text-foreground-500 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 深夜吃瓜 · 保留所有权利</p>
          <p className="flex items-center gap-1.5">
            <i className="ri-shield-check-line" />
            站内话题人物与机构均为虚构化名，仅用于观点讨论
          </p>
        </div>
      </div>
    </footer>
  );
}